import lcmApiClient from "./lcmApiClient";
import { extractInstrumentations } from "../extractors/instrumentationsExtractor";

/* istanbul ignore next */
export async function loadInstrumentations(parameters: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  const response = await lcmApiClient().get("/instrumentations", parameters);
  return {
    instrumentations: extractInstrumentations(response),
    totalCount: (response as $TSFixMe).pagination.total_count,
    nextPageUrl: (response as $TSFixMe).pagination.next,
  };
}

/* istanbul ignore next */
export async function loadNextInstrumentations(nextPageUrl: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 1.
  const response = await lcmApiClient().get(nextPageUrl);
  return {
    instrumentations: extractInstrumentations(response),
    totalCount: (response as $TSFixMe).pagination.total_count,
    nextPageUrl: (response as $TSFixMe).pagination.next,
  };
}
